// "use strict";
var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var ui_extensions = require("ui-extensions");
var cio_config = require("cio-config");

var SnapSet = require("./../../snap/snapSet.js");
var AbstractSelectableInteractionModel = require("../../../abstract/abstractSelectableInteractionModel.js");

var PathHandleModel = require("./pathHandleModel.js");
var PathSegmentModel = require("./pathSegmentModel.js");
var PathBezierSegmentModel = require("./pathBezierSegmentModel.js");
var PathArcSegmentModel = require("./pathArcSegmentModel.js");

var PathInteractionModel = function (pathData, editorModel) {
    var self = this;
    AbstractSelectableInteractionModel.call(this, pathData);

    this.editorModel = editorModel;
    this.origin = editorModel.origin();

    this.boundingBox = this.data.boundingBox;

    this.pointHandles  = this.list("pointHandles", true);
    this.segments = this.list("segments", true);

    this.showStrokeWidth = this.shadow("showStrokeWidth",
        function () {
            return self.data.strokeWidth() / self.origin.getGridFactor();
        },
        function (strokeWidth) {
            return self.data.strokeWidth(Math.abs(strokeWidth || 0) * self.origin.getGridFactor());
        },
        [this.data.strokeWidth, this.origin]
    );

    this.rebuild();

    this.data.objects.forEach(function(index, object) {
        object.type.onChange("rebuild im", function(){
            self.rebuild();
        });
    });

    this.data.objects.onAdd("rebuild_interaction_model", function(index, object){
        object.type.onChange("rebuild im", function(member, old, value){
            self.rebuild();
        });
        self.rebuild();
    }, 10);

    this.data.objects.onRemove("rebuild_interaction_model", function(index, object){
        // todo the next line can be removed if we would have on onBeforeRemove handlers
        // todo or maybe remove all handlers from an object that is removed in some way
        object.removeHandlers("interaction_model_coupling_reverse", true);
        var inFocus = false;
        self.rebuild();
        self.pointHandles.forEach(function (idx, handle) {
            if(handle.selected()) {
                inFocus = true;
            }
        });
        self.setFocus(inFocus);
    }, 10);

    this.data.closed.onChange("rebuild_on_close", function () {
        self.rebuild();
    });
    this.selected.onChange("selectedChanged", function (value) {
        self.setFocus(value);
    });
};
lib_core.inherit(PathInteractionModel, AbstractSelectableInteractionModel);
lib_core.JsonParser.registerClass(PathInteractionModel, "PathInteractionModel");

module.exports = PathInteractionModel;

PathInteractionModel.prototype.doubleClickAction = function (coord, subelement) {
    var path = this.data;

    if(subelement == null)
        return;

    var index = path.objects.indexOf(subelement.object.previous());
    var new_object = subelement.createPathObjectOnSegment(coord);
    path.objects.add(index + 1, new_object);
};

PathInteractionModel.prototype.rebuild = function(handleModel) {
    var self = this;

    if(!handleModel) {
        handleModel = PathHandleModel;
    }

    //store which im were selected or in focus
    var selectedPointHandles = this.pointHandles
        .filter(function(id, pointHandle) { return pointHandle.selected(); })
        .map(function(id, pointHandle) { return pointHandle.object; });
    var inFocusSegments = this.segments
        .filter(function(id, segment) { return segment.infocus(); })
        .map(function(id, segment) { return segment.object; });

    this.data.removeHandlers("interaction_model_coupling_reverse", true);
    this.pointHandles.removeAll();
    this.segments.removeAll();

    var hasNoPoint = true;

    //create handles
    this.data.objects.forEach(function(index, object){
        if (object.type() == cio_datamodel.PathType.POINT) {
            hasNoPoint = false;
        }

        //Make a new handlemodel for each object
        var handle = new handleModel(object, self.editorModel);
        self.pointHandles.push(handle);
    });
    //create segments
    var segmentsList = new lib_core.Collections.List();
    this.data.objects.forEach(function(index, object){
        var next_handle = self.pointHandles.get(index);
        var prev_handle = self.pointHandles.get(index-1); //will wrap around if necessary

        var segment;
        if (object.type() == cio_datamodel.PathType.POINT) {
            if(self.data.closed()) {
                segment = new PathSegmentModel(self, object, next_handle, prev_handle); //pseudo line segment to connect with last handle
            }
        } else if(object.type() == cio_datamodel.PathType.LINE) {
            segment = new PathSegmentModel(self, object, next_handle, prev_handle);
        } else if(object.type() == cio_datamodel.PathType.CURVEC) {
            segment = new PathBezierSegmentModel(self, object, next_handle, prev_handle);
        } else if(object.type() == cio_datamodel.PathType.ARC) {
            segment = new PathArcSegmentModel(self, object, next_handle, prev_handle);
        } else {
            segment = new PathSegmentModel(self, object, next_handle, prev_handle);
        }
        if(segment) {
            segmentsList.push(segment);
        }
    });

    segmentsList.forEach(function(i, segment) { //add to datamodel; do this here so that all prev_handle, next_handle etc have been correctly initialised
        self.segments.push(segment);
    });

    if (hasNoPoint && !this.data.closed()) {
        this.data.removeHandlers("interaction_model_coupling_reverse", true);
        this.pointHandles.removeAll();
        this.segments.removeAll();
        return;
    }

    //reset selection and focus; not very clean solution
    this.pointHandles.forEach(function(id, pointHandle) {
        if(selectedPointHandles.contains(pointHandle.object)) {
            self.editorModel.selectionModel().addToSelection(pointHandle);
        }
    });
    this.segments.forEach(function(id, segment) {
        if(inFocusSegments.contains(segment.object)) {
            self.editorModel.selectionModel().selectedSubElement(segment);
        }
    });
};

PathInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = {};
    inspectorElements.input_elements = [];

    inspectorElements.input_elements.push(
        {
            label       : 'Stroke Width',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showStrokeWidth,
            datatype    : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label       : 'Fill',
            type        : ui_extensions.InspectorInputType.CHECKBOX,
            datamember  : this.data.fill
        }
    );

    inspectorElements.help_elements = {
        'name': 'Path'
    };

    return inspectorElements;
};

PathInteractionModel.prototype.getSnapSet = function () {
    var snapSet = new SnapSet();

    this.pointHandles.forEach(function (index, handle) {
        handle.getSubSnapSet(snapSet);
    });

    this.segments.forEach(function(i, segment) {
        segment.getSubSnapSet(snapSet);
    });
    return snapSet;
};

PathInteractionModel.prototype.rotate = function(angle, center) {
    return this.data.rotate.apply(this.data, arguments);
};

PathInteractionModel.prototype.height = function(newHeight) {
    if(newHeight !== null && newHeight !== undefined && newHeight < 1e-6)
        newHeight = this.data.height() === 0 ? this.data.height() : 1;
    return this.data.height.call(this.data, newHeight);
};

PathInteractionModel.prototype.width = function(newWidth) {
    if(newWidth !== null && newWidth !== undefined && newWidth < 1e-6)
        newWidth = this.data.width() === 0 ? this.data.width() : 1;
    return this.data.width.call(this.data, newWidth);
};

PathInteractionModel.prototype.pos = function(newPos) {
    return this.data.pos.apply(this.data, arguments);
};

PathInteractionModel.prototype.angle = function(newAngle) {
    return this.data.angle.apply(this.data, arguments);
};
